import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconVehiclesBusComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        className="lucide lucide-bus"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 6v6" fill="none" />
        <path d="M15 6v6" fill="none" />
        <path d="M2 12h19.6" fill="none" />
        <path
          d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"
          fill="none"
        />
        <circle cx="7" cy="18" fill="none" r="2" />
        <path d="M9 18h5" fill="none" />
        <circle cx="16" cy="18" fill="none" r="2" />
      </svg>
    </SvgIcon>
  );
};

IconVehiclesBusComponent.displayName = 'IconVehiclesBus';

const IconVehiclesBus = React.memo(IconVehiclesBusComponent);

export default IconVehiclesBus;
